import { call, put, takeLatest } from '@redux-saga/core/effects';
import pcProcessingWorkFlow from 'services/pcProcessingWorkFlow';
import BaseAction from '../actions/baseAction';
import PclAction, { pclTypes } from '../actions/pclAction';

export function* getNoScanReasons(): Generator {
  try {
    const result = yield call(pcProcessingWorkFlow.getPCAcknowledgeNoScanReason);
    if (Array.isArray(result)) {
      yield put(PclAction.getNoScanReasonsSuccess(result));
    }
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_NO_SCAN_REASONS ${error}`,
      }),
    );
  }
}

export const watchPcl = [
  takeLatest(pclTypes.GET_NO_SCAN_REASONS, getNoScanReasons),
];
